import { useState, useEffect } from "react";
import { X, Heart, ChevronRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";

const PatreonLinkNudge = () => {
  const { user, ready } = useAuth();
  const [dismissed, setDismissed] = useState(() => !!localStorage.getItem("wardogs_patreon_link_nudge_dismissed"));
  const [sugg, setSugg] = useState(null);
  const [shown, setShown] = useState(false);
  const [connecting, setConnecting] = useState(false);

  useEffect(() => {
    if (!ready || !user || user === false || dismissed) return;
    let active = true;
    api.get("/patreon/link-suggestion")
      .then((r) => {
        if (active && r.data?.suggest) {
          setSugg(r.data);
          setTimeout(() => active && setShown(true), 400);
        }
      })
      .catch(() => {});
    return () => { active = false; };
  }, [ready, user, dismissed]);

  if (!ready || !user || user === false || dismissed || !sugg) return null;

  const dismiss = () => { localStorage.setItem("wardogs_patreon_link_nudge_dismissed", "1"); setDismissed(true); };
  const connect = async () => {
    setConnecting(true);
    try {
      const { data } = await api.get("/patreon/connect");
      if (data?.url) window.location.href = data.url;
      else setConnecting(false);
    } catch { setConnecting(false); }
  };

  const tier = (sugg.tier_titles || [])[0];

  return (
    <div
      data-testid="patreon-link-nudge"
      className={`fixed bottom-4 right-4 left-4 sm:left-auto z-40 sm:w-[370px] flex items-center gap-3 bg-gradient-to-r from-[#2a0f12] to-[#13151B] border border-[#F96854]/50 tactical-frame-sm px-4 py-3 shadow-[0_10px_40px_rgba(0,0,0,0.55)] transition-all duration-300 ${shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"}`}
    >
      <Heart className="w-4 h-4 text-[#F96854] shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="font-stencil font-black uppercase text-sm text-[#F1F5F9]">You're an OCE DOGS Patron!</div>
        <div className="font-mono text-[11px] text-[#94A3B8] truncate">
          {tier ? `Link your Patreon to unlock your ${tier} perks.` : "Link your Patreon to unlock your VIP perks instantly."}
        </div>
      </div>
      <button
        data-testid="patreon-link-nudge-connect"
        onClick={connect}
        disabled={connecting}
        className="shrink-0 inline-flex items-center gap-1 bg-[#F96854] hover:bg-[#fa7d6c] text-white font-stencil font-black uppercase text-xs px-3 py-2 tactical-frame-sm transition-colors disabled:opacity-50"
      >
        {connecting ? "Linking…" : "Link Patreon"} <ChevronRight className="w-3.5 h-3.5" />
      </button>
      <button
        data-testid="patreon-link-nudge-dismiss"
        onClick={dismiss}
        aria-label="Dismiss"
        className="shrink-0 text-[#64748B] hover:text-[#F1F5F9] transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default PatreonLinkNudge;
